import { useQuery } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';

/**
 * GET /api/eraf/retention-admin/policies/{id} — 보존 정책 상세 (RETENTION_READ)
 * queryKey: ['retention-admin', 'detail', id]
 */
export function useRetentionPolicy(id: number | null) {
  return useQuery({
    queryKey: ['retention-admin', 'detail', id],
    queryFn: () => retentionAdminApi.getPolicy(id!),
    enabled: id !== null,
    staleTime: 30_000,
  });
}
